import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { PromoEntity } from './promo.entity';

// Image attachments for a promo. Mirrors the item_file pattern. Role
// distinguishes hero banner (carousel/dashboard) from thumbnail (cards)
// from supporting gallery shots.
@Index('idx_promo_file_promo_role', ['fkPromoId', 'role', 'sortOrder'])
@Entity('promo_file')
export class PromoFileEntity extends BaseEntity {
	@Column('int', { name: 'fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	@Column('int', { name: 'fk_file__id', unsigned: true })
	public fkFileId!: number;

	@Column('varchar', { name: 'role', length: 32 })
	public role!: 'BANNER' | 'THUMBNAIL' | 'GALLERY';

	@Column('int', { name: 'sortOrder', nullable: true })
	public sortOrder!: number | null;

	@ManyToOne(() => PromoEntity, (promo) => promo.promoFiles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;

	@ManyToOne(() => FileEntity, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
